import { Box, Typography, Stack, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Background from "../assets/Background.svg";
import { MacsAuthenticator } from "../hooks/useMacsAuthenticator";
import { _AuthType } from "../enums";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#303030",
    backgroundImage: `url(${Background})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    position: "relative",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  backgroundImage: {
    height: "100%",
    width: "auto",
    zIndex: 0,
    position: "absolute",
  },
  title: {
    color: "#FFFFFF",
    fontSize: "36px",
    fontWeight: "700",
    textAlign: "justify",
    marginBottom: "16px",
  },
  description: {
    color: "#FFFFFF",
    fontSize: "16px",
    fontWeight: "400",
    textAlign: "justify",
    marginBottom: "32px",
  },
}));

interface ScheduledMaintenanceProps {
  title: string | React.ReactNode;
  description: string | React.ReactNode;
}

export const ScheduledMaintenance = (props: ScheduledMaintenanceProps) => {
  const classes = useStyles();
  const { title, description } = props;

  return (
    <Stack minHeight={550} className={classes.root} id="main">
      <Box>
        <img
          src="https://macs-assets.s3.us-east-1.amazonaws.com/maintenance-page/ScheduledMaintenance.svg"
          alt="Scheduled Maintenance"
        />
      </Box>
      <Box sx={{ width: "498px" }}>
        <Typography variant="h4" component="h4" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="body1" className={classes.description}>
          {description}
        </Typography>

        {MacsAuthenticator.authHook.authType === _AuthType.LTI &&
          MacsAuthenticator.authHook.ltiReturnUrl && (
            <Button
              type="button"
              variant="contained"
              onClick={() => {
                const returnUrl = MacsAuthenticator.authHook.ltiReturnUrl;
                if (returnUrl) window.location.href = returnUrl;
              }}>
              Back to Canvas
            </Button>
          )}
      </Box>
    </Stack>
  );
};
